
import { defineComponent, PropType } from '@vue/composition-api';
import { IFilter } from '~/composables/useFilterSort';
import { Checkbox } from '@fc/angie-ui';

export default defineComponent({
  name: 'DesktopFilterView',
  components: {
    Checkbox,
  },
  props: {
    filters: {
      type: Array as PropType<IFilter[]>,
      default: () => [],
    },
  },
  setup() {
    function toggleSelected(filter: IFilter) {
      // eslint-disable-next-line no-param-reassign
      filter.selected = !filter.selected;
    }

    return {
      toggleSelected,
    };
  },
});
